import React from "react";

export const VoltaBlueSmallLogo = ({ fill = "#0049C6" }) => (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 11.5001H6.83965L6 9.50006H9" fill={fill} />
        <path d="M10.4957 9.50006L12.9975 14.8572L15.4883 9.50006H18L12.9766 19.5001L8 9.50006H10.4957Z" fill={fill} />
        <path
            d="M22.6562 13C22.6562 7.39086 18.1091 2.84375 12.5 2.84375C6.89086 2.84375 2.34375 7.39086 2.34375 13C2.34375 18.6091 6.89086 23.1562 12.5 23.1562V25.5C5.59644 25.5 0 19.9036 0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4036 0.5 25 6.09644 25 13C25 19.9036 19.4036 25.5 12.5 25.5V23.1562C18.1091 23.1562 22.6562 18.6091 22.6562 13Z"
            fill={fill}
        />
    </svg>
);
